import { Typography, Box, useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MobileModal from 'components/Shared/MobileModal';
import CloseIcon from '@material-ui/icons/Close';
import BackgroundBlurImage from 'components/Shared/BackgroundBlurImage';
import { PropsWithChildren } from 'react';
import { IInvite } from 'interface/invites';

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    width: '100%',
    '@media(min-width: 500px)': {
      maxWidth: '72vw',
    },
    background: theme.palette.dark[600],
  },
  section: {
    position: 'relative',
    display: 'flex',
    padding: theme.spacing(3),
    '&:first-of-type': {
      background: theme.palette.dark[50],
    },
    '& h3': {
      height: 16,
      fontSize: 16,
    },
  },
  actions: {
    width: '100%',
    paddingRight: theme.spacing(1),
    '& > div > div, > div': {
      justifyContent: 'space-between',
      width: '100%',
    },
    '& p': {
      display: 'none',
    },
  },
  imageContainer: {
    position: 'relative',
    width: '100%',
    borderRadius: 8,
    overflow: 'hidden',
    minWidth: 142,
    '@media(min-width: 320px)': {
      height: '30.7vw',
    },
    '@media(min-width: 375px)': {
      height: '31vw',
    },
    '@media(min-width: 425px)': {
      height: '31.5vw',
    },
    '@media(min-width: 501px)': {
      height: '33vw',
    },
    '@media(min-width: 768px)': {
      width: 284,
      height: 194,
      minWidth: 284,
      minHeight: 194,
      maxWidth: 284,
      maxHeight: 194,
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    '& svg': {
      color: theme.palette.common.white,
      fontSize: 32,
    },
    '& span': {
      color: theme.palette.common.white,
      fontWeight: 700,
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': 3,
      overflow: 'hidden',
      wordBreak: 'break-word',
      '@media(min-width: 425px)': {
        fontSize: 16,
        maxWidth: 252,
        marginBottom: theme.spacing(2),
      },
    },
  },
  container: {
    width: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
}));

interface IProps {
  open: boolean;
  onClose: () => void;
  imageProps: {
    src: string;
    onError: () => void;
  };
  course: IInvite['course'];
}

const Modal = (props: PropsWithChildren<IProps>) => {
  const classes = useStyles();
  const isTinyScreen = useMediaQuery('@media(max-width: 500px)');

  return (
    <MobileModal
      {...props}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') {
          props.onClose();
        }
      }}
    >
      <div className={classes.root}>
        <div className={classes.section}>
          {isTinyScreen && (
            <Box width='100%' height='auto' marginRight={3}>
              <div className={classes.imageContainer}>
                <BackgroundBlurImage {...props.imageProps} alt={props.course.title} />
              </div>
            </Box>
          )}
          <div className={classes.container}>
            <div className={classes.header}>
              <Typography id='shelves-invite-card-mobile-title' variant='caption'>
                {props.course.title}
              </Typography>
              <CloseIcon onClick={props.onClose} />
            </div>
            {!isTinyScreen && (
              <div className={classes.imageContainer}>
                <BackgroundBlurImage {...props.imageProps} alt={props.course.title} />
              </div>
            )}
          </div>
        </div>
        <div className={classes.section}>
          <div className={classes.actions}>{props.children}</div>
        </div>
      </div>
    </MobileModal>
  );
};

export default Modal;
